import React from "react";
import { useTranslation } from "react-i18next";
import { SpanStyled } from "../../styled/Elements";

export const NoRecord = (props) => {
  const { t } = useTranslation();
  const { padding, size } = props;

  return (
    <div
      className={`h-100 w-100 d-flex align-items-center justify-content-center ${
        padding ? `my-${padding}` : "py-5"
      }`}
    >
      <SpanStyled size={size ||`24px`} weight="600" color="var(--text)">{t("no_data_found")}</SpanStyled>
    </div>
  );
};
